export default function (Component) {
    Component.options.tsv = [{"label":"Panama Papers (2016)","value":2.6},{"label":"Paradise Papers (2017)","value":1.4},{"label":"Pandora Papers (2021)","value":2.94}]
  }